const serverName = "http://43.205.29.55";
const Port = "8001";
const baseURL = serverName + ":" + Port + "/api/";

export default baseURL;

